import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "../components/itemCards/Carousel";
import Divider from "../components/Divider";
import ContactsBlock from "../components/footer/ContactsBlock";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { colors } from "../theme/colors";
import { normalSize } from "../components/itemCards/CarouselSize";
import { fetchItems } from "../redux/actions";

const useStyles = makeStyles({
	itemGroup: {
		margin: "60px 0",
		"& a": {
			color: colors.secondary,
		},
		"& h1": {
			width: "fit-content",
			marginLeft: 50,
			fontFamily: "Open Sans Condensed",
			fontSize: 54,
			marginBottom: 30,
			"@media (max-width: 870px)": {
				marginLeft: 0,
			},
		},
		"@media (max-width: 870px)": {
			margin: "30px 0",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
});

export default function Main() {
	const classes = useStyles();
	const dispatch = useDispatch();

	const tobaccos = useSelector((state) => state.cards.cards.tobacco);
	const consumables = useSelector((state) => state.cards.cards.consumables);
	const cigarettes = useSelector((state) => state.cards.cards.cigarettes);
	const accessories = useSelector((state) => state.cards.cards.accessories);

	useEffect(() => {
		dispatch(fetchItems());
	}, []);

	const carousels = [
		{
			name: "Табак",
			id: "tobacco-carousel",
			type: tobaccos,
			link: "/tobacco/items/tobacco",
		},
		{
			name: "Витратники",
			id: "consumables-carousel",
			type: consumables,
			link: "/tobacco/items/consumables",
		},
		{
			name: "Сигари",
			id: "cigarettes-carousel",
			type: cigarettes,
			link: "/tobacco/items/cigarettes",
		},
		{
			name: "Аксесуари",
			id: "accessories-carousel",
			type: accessories,
			link: "/tobacco/items/accessories",
		},
	];

	return (
		<div className={classes.main}>
			{carousels.map((carousel, index) => {
				return (
					<div key={index}>
						<div className={classes.itemGroup}>
							<h1>
								<NavLink to={carousel.link}>{carousel.name}</NavLink>
							</h1>
							<Carousel escalator={carousel} size={normalSize} />
						</div>
						<Divider />
					</div>
				);
			})}
			<ContactsBlock />
		</div>
	);
}
